import styled from 'styled-components'
import {TableRowProps} from './TableRowProps'

const TableRow = styled.tr<TableRowProps>`
  height: ${({rowHeight, theme}) => rowHeight ?? theme.table.tableBody.rowHeight};
  cursor: ${({cursor}) => cursor ?? 'pointer'};
  border-bottom: ${({borderBottom, theme}) => (borderBottom ? borderBottom : theme.table.tableBody.borderBottom)};
  border-color: ${({borderColor, theme}) => (borderColor ? borderColor : theme.table.tableBody.borderColor)};
  border-radius: ${({borderRadius}) => borderRadius && borderRadius};

  :last-child {
    border-bottom: none;
  }
`

export default TableRow
